import React, { useState, useRef } from "react";
import DOMPurify from 'dompurify';
import { payload } from "../lib/payload"

export default function LLMStream({ face_params, setStreamStarted, streamStarted }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const containerRef = useRef(null);

  async function streamLLM( face_params ) {
    setText("");
    setLoading(true);
    let decoder = new TextDecoder();
    let reader = null;
    
    const data = payload({ face_params })
    const header = {"Authorization": `Bearer ${process.env.REACT_APP_LLM_API_KEY}`, "Content-Type": "application/json"}
  
    try {
      const response = await fetch(process.env.REACT_APP_LLM_URL, {
        method: 'POST',
        headers: header,
        body: JSON.stringify(data),
      });
      reader = response.body?.getReader();
      if (!reader) {
        console.error({"error": "reader unavailable"});
      }
    } catch (e) {
      return {"Error": `Error while fetching llm_url: ${e}`}
    }

    console.log(reader)
    
    let buffer = '';
    try {
      while (true) {
        const { done, value } = await reader.read();
        if (done) break;
        // Append new chunk to buffer
        buffer += decoder.decode(value, { stream: true });
        // Process complete lines from buffer
        while (true) {
          const lineEnd = buffer.indexOf('\n');
          if (lineEnd === -1) break;
          const line = buffer.slice(0, lineEnd).trim();
          buffer = buffer.slice(lineEnd + 1);
          if (line.startsWith('data: ')) {
            const data = line.slice(6);
            if (data === '[DONE]') break;
            try {
              const parsed = JSON.parse(data);
              const content = parsed.choices[0].delta.content;
              if (content) {
                setText((prev) => prev + content);
              }
            } catch (e) {
              // Ignore invalid JSON
            }
          }
        }
      }
    } finally {
      reader.cancel();
      setLoading(false)
    }
  }

  return (
    <div className="p-4">
      <button
        onClick={() => {
          setStreamStarted(true);
          streamLLM(face_params);
        }}
        className="px-4 py-2 text-white rounded bg-gradient-to-r from-purple-500 via-pink-500 to-red-500 
        hover:from-purple-600 hover:via-pink-600 hover:to-red-600 transition-all duration-300"
        disabled={loading}
      >
        {loading ? "Generating..." : "Get AI Suggestions"}
      </button>

      {streamStarted && (
        <div 
          ref={containerRef}
          className="mt-4 p-2 border rounded min-h-[100px] whitespace-pre-wrap prose prose-a:text-blue-600 hover:prose-a:text-blue-500"
          dangerouslySetInnerHTML={{ 
            __html: DOMPurify.sanitize(text, { 
              ADD_ATTR: ['target', 'rel', 'class'],
              ADD_TAGS: ['a'],
              ALLOWED_ATTR: ['href', 'class'],
              ALLOWED_CLASSES: ['ai-link']
            }) 
          }}
        />
      )}
    </div>
  );
}

